import { UpgradeIds, UpgradeTypes } from '../enums'
import type { Upgrade } from '../../../../types/Upgrade'
import { DepartmentIds } from '../../departments'

const array: Upgrade[] = [
	{
		name: 'Lettersmiths',
		resource: 'swm_exponent_1',
		id: UpgradeIds.SwmExponent1,
		description:
			"Replace your wordsmiths with lettersmiths. They won't be great at writing speeches, but they know all the fonts.",
		cost: 10_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	},
	{
		name: 'Malpractice Sessions',
		resource: 'swm_exponent_2',
		id: UpgradeIds.SwmExponent2,
		description:
			'Make sure your speeches are learned as poorly as they are written, every midnight for two hours.',
		cost: 500_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	},
	{
		name: 'China Update',
		resource: 'swm_exponent_3',
		id: UpgradeIds.SwmExponent3,
		description:
			'Write your speeches in Chinese instead. Your lettersmiths will like this one.',
		cost: 70_000_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	},
	{
		name: 'Post on Xiaohongshu',
		resource: 'swm_exponent_4',
		id: UpgradeIds.SwmExponent4,
		description:
			'Your reach is still too large. Exclusively publishing your speeches here might solve that problem.',
		cost: 10_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	},
	{
		name: 'Wingdings',
		resource: 'swm_exponent_5',
		id: UpgradeIds.SwmExponent5,
		description:
			'Read your speeches in Wingdings. How? Not your job to find out.',
		cost: 2_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	},
	{
		name: 'Speechless',
		resource: 'swm_exponent_6',
		id: UpgradeIds.SwmExponent6,
		description: 'Silence speaks louder than words.',
		cost: 500_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	},
	{
		name: 'Brick Wall',
		resource: 'swm_exponent_7',
		id: UpgradeIds.SwmExponent7,
		description: 'Why speak to an audience anyway?',
		cost: 100_000_000_000_000_000,
		effects: [
			{
				for: [DepartmentIds['Speech Writing Mill']],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [DepartmentIds['Speech Writing Mill']]
		}
	}
]

export default array
